import { Icon } from '@gftg/ui';
import { Link } from 'react-router';
import { Avatar } from './Avatar';

interface CardRowProps {
  to: string;
  title: string;
  subtitle?: string | null;
  /** A third line, quieter than the subtitle: a session count, a time, a place. */
  meta?: string | null;
  /** Draws the avatar disc, from the person's photograph or their initials. */
  personName?: string;
  photoAssetId?: string | null;
}

/**
 * One tappable card in a list of them: presenters, the sessions a presenter appears in, the
 * speakers of a session. They looked the same on three screens before they were one component,
 * and the 64px row and the hairline chevron are the kit's, not this file's invention.
 */
export function CardRow({ to, title, subtitle, meta, personName, photoAssetId }: CardRowProps) {
  return (
    <Link
      to={to}
      className="rounded-card flex min-h-row items-center gap-3 border border-border bg-surface px-4 py-3"
    >
      {personName && <Avatar name={personName} photoAssetId={photoAssetId} />}

      <span className="min-w-0 flex-1">
        <span className="text-row block font-semibold text-ink">{title}</span>
        {subtitle && <span className="text-subtitle mt-0.5 block text-ink-3">{subtitle}</span>}
        {meta && <span className="text-eyebrow mt-1.5 block text-ink-4">{meta}</span>}
      </span>

      <Icon name="chevron-right" size={18} className="shrink-0 text-hairline" />
    </Link>
  );
}
